import React, {FC} from 'react';
import cls from 'classnames';
import {TableCell, TableProps, TableRow} from './Table.types';
import { getClassNames, getRootClassListFromProps } from '../../../utilities/classNames';
import { iconTokensMap } from "@stashinvest/react-assets"

export const classNames = getClassNames('sds-table',[
	'bottom-divider','col-selected',
]);


const Table: FC<TableProps> = (props) => {
	const { className, tableId, tableAriaLabel, headerRow, contentRows, selectedColumn } = props
	const tableKey = tableId.replace(/\s/g, "");

	const getHeaderRow = (headerRow?: TableRow) =>
		headerRow && (
			<thead>
				<tr className={`${headerRow.isDividerHidden ? '' : classNames.bottomDivider} h-[3.5rem]`}>
					{headerRow.columns.map((col, c) => getHeaderColumn(col, 0, c))}
				</tr>
			</thead>
		)

	const getHeaderColumn = (col: TableCell, rowIdx: number, colIdx: number) => (
		<th className='captionSmallEmphasize rounded-t-lg' key={`${tableKey}HeaderRow${rowIdx}Column${colIdx}`} scope="col">{col.text}</th>
	)

	const getColGroup = (range: number) => {
		return <colgroup>
			{
				Array.from({length: range}, (v, i) =>
					{
						let classes =  i === selectedColumn ? classNames.colSelected : ''
						if (i !== 0) classes += " w-[30%]"
						return <col key={`${tableKey}ColGroupCol${i}`} className={classes}/>
					}
				)
			}
		</colgroup>;
	}

	const getContentRows = (contentRows?: TableRow[]) => (
		contentRows?.map((row, r) =>
			<tr key={`${tableKey}ContentRow${r}`}
				className={`${row.isDividerHidden ? '' : classNames.bottomDivider} h-[3.5rem]`}>
				{row.columns.map((col, c) => getContentColumn(col, r, c, r === contentRows.length - 1))}
			</tr>
		)
	)

	const getContentColumn = (col: TableCell, rowIdx: number, colIdx: number, isLastRow: boolean) => {
		const classes = `bodySmallStandard ${isLastRow ? ' rounded-b-lg': ''}`
		const key = `${tableKey}ContentRow${rowIdx}Column${colIdx}`
		if (col.icon) {
			const Icon = iconTokensMap[col.icon].component
			return (
				<td className={classes} key={key}>
					<Icon size={'XS'}/>
				</td>
			)
		} else {
			return (
				<td className={classes} key={key}>
					{ col.text }
				</td>
			)
		}
	}

	return <table className={cls(getRootClassListFromProps(classNames,props), className)} aria-label={tableAriaLabel}>
			{getColGroup(Math.max((headerRow?.columns.length || 0), (contentRows?.[0].columns.length || 0)))}
			{getHeaderRow(headerRow)}
			<tbody>
				{getContentRows(contentRows)}
			</tbody>
		</table>;
};

Table.displayName = 'Table';

export default Table;
